import { ProjectWithAssigneesDto } from '../../../commonTypes/acs';
import useHttpGetProjectWithClientUserBranch from '../../../hooks/acs/acsApi/useHttpGetProjectWithClientUserBranch';
import { MixerLoader } from '../../Common';
import ProjectMembers from '../ProjectMembers';
import ProjectOverview from '../ProjectOverview';
import { ProjectAssigneesWithUserInfoDto } from '../../../commonTypes/project.types';

interface ProjectDetailsProps {
    project: ProjectWithAssigneesDto;
    reFetchProject: (assigneeStatus?: string) => void;
    setIsDeleteYesNoVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setIsAddAssigneeVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setIsEditAssigneeVisible: React.Dispatch<React.SetStateAction<boolean>>;
    activateAssignee: (assignee: ProjectAssigneesWithUserInfoDto) => void;
    selectAssignee: (assignee: ProjectAssigneesWithUserInfoDto) => void;
    assigneeToDelete: React.MutableRefObject<string | null>;
}

const ProjectDetails = ({
    project,
    reFetchProject,
    setIsAddAssigneeVisible,
    setIsDeleteYesNoVisible,
    setIsEditAssigneeVisible,
    selectAssignee,
    activateAssignee,
    assigneeToDelete,
}: ProjectDetailsProps) => {
    return (
        <div className="project-details">
            <div className="project-details__overview">
                <ProjectOverview project={project} />
            </div>
            <div className="project-details__members">
                <ProjectMembers
                    project={project}
                    reFetchProject={reFetchProject}
                    setIsAddAssigneeVisible={setIsAddAssigneeVisible}
                    setIsYesNoVisible={setIsDeleteYesNoVisible}
                    setIsEditAssigneeVisible={setIsEditAssigneeVisible}
                    activateAssignee={activateAssignee}
                    selectAssignee={selectAssignee}
                    assigneeToDelete={assigneeToDelete}
                />
            </div>
        </div>
    );
};

interface ProjectDetailsSafetyWrapperProps {
    projectId: string;
    setIsDeleteYesNoVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setIsAddAssigneeVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setIsEditAssigneeVisible: React.Dispatch<React.SetStateAction<boolean>>;
    activateAssignee: (assignee: ProjectAssigneesWithUserInfoDto) => void;
    selectAssignee: (assignee: ProjectAssigneesWithUserInfoDto) => void;
    assigneeToDelete: React.MutableRefObject<string | null>;
}

const ProjectDetailsSafetyWrapper = ({
    projectId,
    setIsAddAssigneeVisible,
    setIsDeleteYesNoVisible,
    setIsEditAssigneeVisible,
    activateAssignee,
    selectAssignee,
    assigneeToDelete,
}: ProjectDetailsSafetyWrapperProps) => {
    const { project, isReady, getProjects } = useHttpGetProjectWithClientUserBranch(projectId);

    if (!isReady) return <MixerLoader position="centerOnParent" />;
    if (!project) return <div>No data available</div>;

    return (
        <ProjectDetails
            project={project}
            reFetchProject={getProjects}
            setIsAddAssigneeVisible={setIsAddAssigneeVisible}
            setIsDeleteYesNoVisible={setIsDeleteYesNoVisible}
            setIsEditAssigneeVisible={setIsEditAssigneeVisible}
            activateAssignee={activateAssignee}
            selectAssignee={selectAssignee}
            assigneeToDelete={assigneeToDelete}
        />
    );
};

export { ProjectDetailsSafetyWrapper as ProjectDetails };
